<template>
<div class="wrapper">
  <div class="container">
    <div class="row">
      <div class="col-md-12 dashboardOrders">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
               <h2><span class="fontIcon"></span>Aktiva ordrar</h2>
               <ActiveTrucks :trucks = "filteredMapArray" />
            </div>
          </div>
        </div>
        <DashBoardOrders :needsAttention = false :limit = 20 :showFilter= false :userCustomerId="userCustomerId" />
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Map from '@/components//Map/Map'
import ActiveTrucks from '@/components/Map/ActiveTrucks'
import DashBoardOrders from '@/components/Orders/OrderList'
import Chart from 'primevue/chart'
import moment from 'moment'
import store from '../store.js'
export default {
  name: 'Dashboard',
  components: {
    Map,
    DashBoardOrders,
    Chart,
    ActiveTrucks,
    'moment': moment
  },
  data () {
    return {
      msg: 'Välkommen till Transplan',
      trucks: '',
      dataArray: [],
      filteredMapArray: [],
      timer: '',
      isLoggedIn: false,
      userCustomerId: null,
      role: '',
      basicData: {
        labels: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli'],
        datasets: [
          {
            label: 'Avslutade ordrar 2019',
            backgroundColor: '#42A5F5',
            data: [65, 59, 80, 81, 56, 55, 40]
          },
          {
            label: 'Avslutade ordrar 2018',
            backgroundColor: '#9CCC65',
            data: [28, 48, 40, 19, 86, 27, 90]
          }
        ]
      },
      driverData: {
        labels: ['Jan Eriksson', 'Gunnar Persson', 'Mats Ek', 'Wilmer Johansson', 'Pelle Svahn'],
        datasets: [
          {
            label: 'Ordrar',
            backgroundColor: '#42A5F5',
            data: [65, 59, 80, 81, 56, 55]
          }
        ]
      },
      chartData: {
        labels: ['Nya', 'Uppdaterade', 'Aktiva', 'Avslutade', 'Fakturerade'],
        datasets: [
          {
            data: [300, 50, 100, 200, 300],
            backgroundColor: [
              '#fff3cd',
              '#36A2EB',
              '#d1ecf1',
              '#29B200'
            ],
            hoverBackgroundColor: [
              '#fff3cd',
              '#36A2EB',
              '#d1ecf1',
              '#29B200'
            ]
          }
        ]
      },
      options: {
        legend: {
          display: true,
          position: 'left',
          labels: {
            fontColor: 'rgb(0, 0, 0)'
          }
        }
      }
    }
  },
  async created () {
    if (localStorage.getItem('userCustomerId')) {
      this.userCustomerId = localStorage.getItem('userCustomerId')
    }
    if (store.getters.isLoggedIn) {
      this.isLoggedIn = true
      this.role = localStorage.getItem('role')
      await this.getTrucks()
      // this.timer = setInterval(async () => {
      //   await this.getTrucks()
      // }, 30000)
    } else {
      this.$router.push('/')
    }
  },
  methods: {
    filterMapTrucks (btnState) {
      if (btnState !== 'all') {
        this.filteredMapArray = JSON.parse(JSON.stringify(this.dataArray))
        // this.filteredMapArray = this.filteredMapArray.filter((el) => el.OrderType === btnState)
        this.filteredMapArray = this.filteredMapArray.filter((el) => btnState.includes(el.OrderType))
      } else {
        this.filteredMapArray = JSON.parse(JSON.stringify(this.dataArray))
      }
    },
    async getTrucks () {
      let apiCall = '/api/orders/by-active'
      if (this.userCustomerId !== null && this.userCustomerId !== 'null') {
        apiCall = '/api/orders/by-active/' + this.userCustomerId
      }
      this.$http
        .get(apiCall)
        .then(async response => {
          var orders = response.data
          orders.forEach(async (order) => {
            if (order.data.trucks) {
              for (var i = 0; i < order.data.trucks.length; i++) {
                let lastOrderRow = ''
                let filteredOrderRows = order.data.orderRows.filter((c) => c.truckId === order.data.trucks[i].id)
                if (filteredOrderRows.length > 0) {
                  lastOrderRow = filteredOrderRows.slice(-1)[0]
                  var activeState = lastOrderRow.actions.slice(-1)[0].name
                  let driverName = lastOrderRow.actions.slice(-1)[0].user
                  // for (var b = 0; b < lastOrderRow.actions.length; b++) {
                  //   if (lastOrderRow.actions[b].endTime) {
                  //     activeState = 'Utförs'
                  //   }
                  // }
                  if (activeState === 'Startad') {
                    activeState = 'Aktiv'
                  }
                  var destination = ''
                  if (order.data.DeliveryPlaceCity) {
                    destination = order.data.DeliveryPlaceCity
                  } else if (order.data.CustomerPlaces) {
                    destination = order.data.CustomerPlaces[0].data.name
                  } else {
                    destination = order.data.customerPlaceName
                  }
                  let truckObj = { State: activeState, OrderType: order.type, Name: order.data.trucks[i].name, Driver: driverName, Order: order, OrderId: order.id, Destination: destination, Title: order.data.trucks[i].name }
                  let isAlreadyAddedObject = this.dataArray.find(x => x.Name === truckObj.Name)
                  if (activeState !== 'Sparad') {
                    if (isAlreadyAddedObject) {
                      this.filteredMapArray.push(...truckObj)
                    } else {
                      this.filteredMapArray.push(truckObj)
                    }
                  }
                }
              }
            } else {
              let truckName = ''
              let driverName = ''
              if (order.data.orderRows) {
                let orderRow = order.data.orderRows[0]
                truckName = order.data.orderRows[0].truckName
                driverName = order.data.orderRows[0].actions.slice(-1)[0].user
                var activeState2 = orderRow.actions.slice(-1)[0].name
                if (orderRow.actions.slice(-1)[0].name === 'Lastar' && orderRow.actions.slice(-1)[0].endTime) {
                  activeState2 = 'Lastad'
                } else if (orderRow.actions.slice(-1)[0].name === 'Lossar' && orderRow.actions.slice(-1)[0].endTime) {
                  activeState2 = 'Lossad'
                }
                if (activeState2 === 'Startad') {
                  activeState2 = 'Aktiv'
                }
                // for (var c = 0; c < orderRow.actions.length; c++) {
                //   if (orderRow.actions[c].endTime) {
                //     if (orderRow.actions[c].name === 'Lastar') {
                //       activeState2 = 'Lastad'
                //     } else {
                //       activeState2 = 'Utförs'
                //     }
                //   }
                // }
              }
              var destination2 = ''
              if (order.data.DeliveryPlaceCity) {
                destination2 = order.data.DeliveryPlaceCity
              } else if (order.data.deliveryPlaces) {
                destination2 = order.data.deliveryPlaces
              } else {
                destination2 = order.data.customerPlaceName
              }
              let truckObj = { State: activeState2, OrderType: order.type, Name: truckName, Driver: driverName, Order: order, OrderId: order.id, Destination: destination2, Title: truckName } //, Data: Data }
              let isAlreadyAddedObject = this.dataArray.find(x => x.OrderId === order.id)
              if (isAlreadyAddedObject) {
                this.filteredMapArray.push(...truckObj)
              } else {
                this.dataArray.push(truckObj)
                this.filteredMapArray.push(truckObj)
              }
            }
          })
        })
    },
    cancelAutoUpdate () { clearInterval(this.timer) }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue